/*
 * @Description 组件 Index主页
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- app-header start -->
	<div class="app-header">
		<!-- app-title start -->
		<div class="app-title abs-center ">
      {{systemName}}
    </div>
		<!-- app-title end -->
		
		<!-- header-items-box start -->
		<div class="header-items-box left">

			<!-- logo start -->
			<div v-if="false" class="h-l-item" style="max-height: 100%;margin-right: 10px;">
				<img src="~@/static_dazzle/images/system/logos/SystemLogo.png" style="display: block;height: 50px;width: auto;transform: scale(1.5);"/>
			</div>
			<!-- logo end -->
			
		</div>
		<!-- header-items-box end -->

		<!-- header-items-box start -->
		<div class="header-items-box right">
			
			<!-- 视图缩放 start -->
			<div class="h-r-item">
				<!-- 组件 ScreenScale dropdown -->
				<ScreenScale />
			</div>
			<!-- 视图缩放 end -->
			
			<!-- 设置 start -->
			<div class="h-r-item" style="margin-right: 0px;">
				<!--  下拉菜单-->
				<el-dropdown @command="handleCommand" trigger="click">
					<!--  绑定指令,在methods里定义-->
					<span class="el-dropdown-link mine-btn cursor-pointer">
						<span class="iconfont el-icon-my_liuliangyunpingtaitubiao08 dp-mine-bg"></span>
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<!-- icon是修改图标 ，command是点击后传给方法的值-->
						<template v-for="(item, index) in mineDropdown">
							<el-dropdown-item :icon="item.icon" :command="item.command">&gt;&nbsp;{{item.text}}</el-dropdown-item>
						</template>
					</el-dropdown-menu>
				</el-dropdown>
				<!--  下拉菜单结束-->
			</div>
			<!-- 设置 end -->
			
		</div>
		<!-- header-items-box end -->
		
		<!-- 修改密码 -->
		<PasswordDialog ref="PasswordDialog" />
    <SystemDialog ref="SystemDialog" @updateSystemParam="updateSystemParam"/>
		
	</div>
	<!-- app-header end -->
</template>

/* JS */
<script>
	// 组件 左侧导航
	import Navbar from '../AppNavbar';
	// 组件 license dropdown
	import LicenseDropDown from '@/components_index/License/LicenseDropDown';
	// 组件 屏幕比例
	import ScreenScale from "../Screen/ScreenScale";
	// 组件 资源下载
	import FilesDownload from "../FilesDownload/FilesDownload";
	// 组件 修改密码
  import PasswordDialog from '@/components_pages/Account/PasswordDialog';
  import SystemDialog from '@/components_pages/Account/SystemDialog';
  //
  import Account from '@/request/api-account'
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
		name: "Header",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
    components: {
        	ScreenScale,
        	// 组件 左侧导航
        	Navbar,
        	// 组件 license dropdown
        	LicenseDropDown,
        	// 组件 资源下载
        	FilesDownload,
        	// 组件 修改密码
        	PasswordDialog,
          SystemDialog,
    },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				/**
				 * @Des 我的（dropdown）
				 * @Auth 
				 * @Date 
				 */
				mineDropdown: [
					/*{icon: 'el-icon-user-solid',command: 'userInfo',text: '个人信息'},*/
					/*{icon: 'el-icon-thumb',command: 'accountRole',text: '角色授权'},*/
					{icon: 'el-icon-s-tools',command: 'sysSet',text: '系统设置'},
					{icon: 'el-icon-edit',command: 'editPassword',text: '修改密码'},
					{icon: 'el-icon-switch-button',command: 'logOut',text: '安全退出'},
				],// mineDropdown

        systemName: "定位管理云平台",
        systemLogo: "",
				
				// 展示导航
				showMenuFlag: true,

				fullWidth: document.documentElement.clientWidth,
				
				// 授权信息
                authInfo: null,
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			window.addEventListener('resize', this.handFleResize)
      this.getSystemName();
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
      /**
       * 获取系统名称
       */
      getSystemName(){
        this.$request.postJsonRequest(Account.searchAccountSystemNameApi, {}).then(result => {
          if(result.code == 0 && result.data && result.data.systemName) {
            this.systemName = result.data.systemName;
            this.systemLogo = result.data.systemLogo;
          }
        }).catch(error => {
        })
      },

			/**
		     * @Des 显示/隐藏 左侧导航
		     * @Auth 
		     * @Date 
		     */
			toggleMenuItem(flag) {
				// 展示导航
				this.showMenuFlag = flag && true;
			},
			
			/**
		     * @Des 授权信息
		     * @Auth 
		     * @Date 
		     */
			changeAutoInfo(info) {
				// 空值 中止
				if (this.$checkEmpty(info)) return false;
				// 授权信息
                this.authInfo = Object.assign({}, info);
			},// changeAutoInfo
			
			/**
		     * @Des 处理Command
		     * @Auth 
		     * @Date 
		     */
			handleCommand(command){
				this[command] && this[command]();
			},

			/**
			 * @Des 退出登陆
			 * @Auth 
			 * @Date 
			 */
			logOut() {
				this.$confirm('确认要退出系统吗？', '安全退出', {
					closeOnClickModal : false,
					type: 'warning'
				}).then(_ => {
					// 移除本地记录
					// window.localStorage.clear();
					
					// 移除状态记录
					this.removeStorage();
					
					// 移除cookie
					this.removeCookies();
					this.$router.replace({path: '/'}, ()=>{}, ()=>{});
				}).catch(_ => {
					//this.$message('取消删除');
				});
			},
			/**
			 * @Des 修改密码
			 * @Auth 
			 * @Date 
			 */
			editPassword() {
				const row = {
					accountId: this.$store.state.accountId,
					userName: this.$store.state.userName
				};
				this.$refs.PasswordDialog.openDialog(true, row);
			},
			
			/**
			 * @Des 移除cookie
			 * @Auth 
			 * @Date 
			 */
			removeCookies() {
				this.$cookies.remove("username");
				this.$cookies.remove("usernameSecret");
				this.$cookies.remove("passwordSecret");
			},
			// 移除状态记录
			removeStorage() {
				// 移除登录信息
				this.$store.dispatch("commitRemoveUserName");
				this.$store.dispatch("commitRemoveAccount");
				this.$store.dispatch("commitRemoveAccountId");
				
				this.$store.dispatch("commitToken", '1');
				this.$store.dispatch("commitLang", 'zh');
			},// removeStorage
			
			/**
			 * @Des 个人信息
			 * @Auth 
			 * @Date 
			 */
			userInfo() {
				// this.$message('个人信息'); return false;
				const row = {
					accountId: this.$store.state.accountId
				};
				this.$refs.UserInfoDialog.openDialog(true, row);
			},
			/**
			 * @Des 账户权限
			 * @Auth 
			 * @Date 
			 */
			accountRole() {
				// 路由 跳转
				this.$router.replace({path: '/manager/system/account'}, ()=>{}, ()=>{});
			},
			/**
			 * @Des 设置
			 * @Auth 
			 * @Date 
			 */
			sysSet() {
        const row = {
          systemLogo: this.systemLogo,
          systemName: this.systemName
        };
        this.$refs.SystemDialog.openDialog(true, row);
			},

      updateSystemParam(param){
          this.systemLogo = param.logo;
          this.systemName = param.name;
      },

			/**
			 * @Author ZhangBin
			 * @Description //TODO 屏幕缩放
			 * @Date 9:07 2022/8/25
			 * @Param
			 * @return
			 **/
			reduce(zoom=1){
				
			},


		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/AppHeader/index.vue